import React, { useState } from "react";
import styled from "@emotion/styled";
import ImageTitle from "../components/ImageTitle";
import CatalogImage from "../assets/images/CNC-Catalog.jpg";
import CertificatesFONE from "../components/CertificatesFONE";
import CertificatesCECAP from "../components/CertificatesCECAP";
import CertificatesAPS from "../components/CertificatesAPS";
import { jsPDF } from "jspdf";
import Oswald from "../assets/fonts/Oswald-Medium.ttf";
import Roboto from "../assets/fonts/Roboto-Medium.ttf";
import RobotoLight from "../assets/fonts/Roboto-Light.ttf";
import RobotoBold from "../assets/fonts/Roboto-Bold.ttf";
import {
  TextField,
  Button,
  ToggleButton,
  ToggleButtonGroup,
  Alert,
  CircularProgress,
  Card,
  CardContent,
  Divider,
  Grid,
  Typography,
  Collapse,
  Box,
} from "@mui/material";
import { IoIosSearch } from "react-icons/io";
import { QRCodeSVG } from "qrcode.react";
import { MdDownload, MdVerified, MdPerson } from "react-icons/md";
import { BsFilePdfFill, BsCalendar2Check, BsTag, BsShieldCheck } from "react-icons/bs";
import axios from "axios";

const GreenDiv = styled.div`
  background: linear-gradient(0.25turn, #005522, #069640, #005522);
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 10;
`;

const Title = styled.p`
  font-family: "League Gothic", serif;
  font-size: 55px;
  color: white;
  margin: 0px;
`;

const Descripcion = styled.p`
  font-family: "DM Sans", serif;
  font-size: 15px;
  color: black;
  padding: 20px;
  text-align: justify;
  width: 70%;
  margin: auto;
`;

const SearchCard = styled.div`
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.10);
  padding: 32px 40px;
  width: 70%;
  margin: 32px auto;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: 768px) {
    width: 90%;
    padding: 20px;
  }
`;

const SearchRow = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

const WelcomeBar = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  padding: 20px 28px;
  width: 70%;
  margin: 0 auto 8px auto;
  display: flex;
  align-items: center;
  gap: 16px;

  @media (max-width: 768px) {
    width: 90%;
  }
`;

const CertGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  width: 70%;
  margin: 16px auto;

  @media (max-width: 768px) {
    width: 90%;
    grid-template-columns: 1fr;
  }
`;

const CertCard = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-top: 4px solid #069640;
`;

const CertRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: "DM Sans", sans-serif;
  font-size: 14px;
  color: #444;
`;

const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 80%;
  margin: auto;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }
`;

const Certificates = () => {
  // Estados búsqueda por CURP
  const [curp, setCurp] = useState("");
  const [loadingCurp, setLoadingCurp] = useState(false);
  const [resultadosCurp, setResultadosCurp] = useState(null);
  const [errorCurp, setErrorCurp] = useState("");
  const [usuarioInfo, setUsuarioInfo] = useState(null);

  // Estados para búsqueda externa (CENCAD, CEC)
  const [nombre, setNombre] = useState("");
  const [tipoExterno, setTipoExterno] = useState("CENCAD");
  const [loadingExterno, setLoadingExterno] = useState(false);
  const [resultadoExterno, setResultadoExterno] = useState(null);
  const [errorExterno, setErrorExterno] = useState("");

  // Estados para segundo factor de seguridad
  const [mostrarQR, setMostrarQR] = useState(false);
  const [mostrarSeguridad, setMostrarSeguridad] = useState(false);
  const [codigoSeguridad, setCodigoSeguridad] = useState("");
  const [loadingCodigo, setLoadingCodigo] = useState(false);
  const [resultadoCodigo, setResultadoCodigo] = useState(null);

  const API_URL = process.env.REACT_APP_API_URL || "https://crm-backend-5tk6.onrender.com";

  // Búsqueda por CURP
  const handleSearchCurp = async (e) => {
    e.preventDefault();
    if (!curp.trim() || curp.trim().length < 18) {
      setErrorCurp("Ingresa una CURP válida de 18 caracteres.");
      return;
    }
    setLoadingCurp(true);
    setErrorCurp("");
    setResultadosCurp(null);
    setUsuarioInfo(null);

    try {
      const response = await axios.get(`${API_URL}/api/buscar-certificados`, {
        params: { curp: curp.trim() }
      });
      if (response.data.encontrado && response.data.certificados?.length > 0) {
        setResultadosCurp(response.data.certificados);
        setUsuarioInfo(response.data.usuario || null);
      } else {
        setErrorCurp("No se encontraron certificados asociados a esta CURP.");
      }
    } catch (err) {
      if (err.response?.status === 404) {
        setErrorCurp("No se encontraron certificados asociados a esta CURP.");
      } else {
        setErrorCurp("Error al buscar. Intenta más tarde.");
      }
    } finally {
      setLoadingCurp(false);
    }
  };

  // Handler para búsqueda externa
  const handleSearchExterno = async (e) => {
    e.preventDefault();
    if (!nombre.trim()) {
      setErrorExterno("Por favor ingresa un nombre");
      return;
    }
    setLoadingExterno(true);
    setErrorExterno("");
    setResultadoExterno(null);
    setMostrarQR(false);
    setMostrarSeguridad(false);
    setCodigoSeguridad("");
    setResultadoCodigo(null);

    try {
      const response = await axios.get(`${API_URL}/api/buscar-constancia`, {
        params: { nombre: nombre.trim(), tipo: tipoExterno }
      });
      if (response.data.encontrado && response.data.resultados?.length > 0) {
        setResultadoExterno(response.data.resultados[0]);
      } else {
        setErrorExterno("No se encontró ninguna constancia con ese nombre.");
      }
    } catch (err) {
      if (err.response?.status === 404) {
        setErrorExterno("No se encontró ninguna constancia con ese nombre");
      } else {
        setErrorExterno("Error al buscar la constancia. Intenta más tarde.");
      }
    } finally {
      setLoadingExterno(false);
    }
  };

  const handleVerificarCodigo = async () => {
    if (!codigoSeguridad.trim() || codigoSeguridad.length !== 8) return;
    setLoadingCodigo(true);
    setResultadoCodigo(null);
    try {
      const response = await axios.post(`${API_URL}/api/verificar-codigo`, {
        folio: resultadoExterno.folio,
        codigo_validacion: codigoSeguridad.trim(),
        tipo: resultadoExterno.tipo,
      });
      setResultadoCodigo(response.data);
    } catch {
      setResultadoCodigo({ valido: false, mensaje: "Error al verificar. Intenta de nuevo." });
    } finally {
      setLoadingCodigo(false);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "—";
    return new Date(dateStr).toLocaleDateString("es-MX", {
      day: "2-digit", month: "long", year: "numeric"
    });
  };

  const nombreCursoFormateado = (cert) => {
    const mapaCursos = {
      "BASICO": "Programa Nacional TUM-B",
      "ACTUALIZACION": "Actualización TUM",
      "AVANZADO": "Programa Nacional TUM-A",
    };
    return mapaCursos[cert.nombre_curso?.toUpperCase()] || cert.nombre_curso || cert.tipo;
  };

  const formatearFecha = (fechaISO) => {
    if (!fechaISO) return "";
    const date = new Date(fechaISO);
    return new Intl.DateTimeFormat("es-ES", {
      day: "2-digit", month: "long", year: "numeric",
    }).format(date);
  };

  const toBase64 = async (url) => {
    const res = await fetch(url);
    const buf = await res.arrayBuffer();
    let binary = "";
    const bytes = new Uint8Array(buf);
    const chunk = 0x8000;
    for (let i = 0; i < bytes.length; i += chunk) {
      binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk));
    }
    return btoa(binary);
  };

  const addFontToDoc = async (doc, srcUrl, vfsName, fontName) => {
    const b64 = await toBase64(srcUrl);
    doc.addFileToVFS(vfsName, b64);
    doc.addFont(vfsName, fontName, "normal");
  };

  const imageToDataUrl = (img) => {
    const canvas = document.createElement("canvas");
    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;
    canvas.getContext("2d").drawImage(img, 0, 0);
    return canvas.toDataURL("image/png");
  };

  // Helper para imágenes externas o con crossOrigin (fondos, plantillas)
  const loadImageHelper = (src) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = src;
    });

  // Helper para fotos CURP del mismo servidor:
  // Usa fetch → blob URL para evitar problemas de CORS/crossOrigin con Hostinger.
  const loadLocalImage = async (src) => {
  const response = await fetch(src);
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  const blob = await response.blob();

  // Convierte a base64 en lugar de blob URL (evita restricciones de CSP)
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = reader.result; // data:image/png;base64,...
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

  const generarConstancia = async (cert) => {
    const { folio, delegacion_estatal, delegacion_local, nombre_curso, fecha_emision, vigencia, curp, tipo } = cert;
    const nombreCompleto = cert.nombre_completo || "";

    // ── CECAP: portrait + foto CURP ──────────────────────────────
    if (tipo === "CECAP") {
      const doc = new jsPDF({ orientation: "portrait", unit: "px", format: [612, 792] });

      try {
        await Promise.all([
          addFontToDoc(doc, Oswald, "Oswald-Medium.ttf", "Oswald"),
          addFontToDoc(doc, Roboto, "Roboto-Medium.ttf", "Roboto"),
          addFontToDoc(doc, RobotoLight, "Roboto-Light.ttf", "RobotoLight"),
          addFontToDoc(doc, RobotoBold, "Roboto-Bold.ttf", "RobotoBold"),
        ]);

        // Cargar fondo
        const bgImg = await loadImageHelper(
          `${process.env.PUBLIC_URL}/assets/certificate/CertificateEmpty.png`
        );
        const bgData = imageToDataUrl(bgImg);
        doc.addImage(bgData, "PNG", 0, 0, 612, 792);
        console.log("✅ Imagen de fondo cargada");

        // Cargar foto CURP — ruta directa en /assets/ImgCurp/
        // Doble fallback: .png → .PNG
        let imgPart = null;
        try {
          const url1 = `/assets/ImgCurp/${curp}.png`;
          console.log("🔍 Intentando cargar:", url1, "| curp:", curp);
          imgPart = await loadLocalImage(url1);
          console.log("✅ Foto CURP cargada (.png):", curp);
        } catch (e) {
          console.error("❌ Error .png:", e);
          try {
            const url2 = `/assets/ImgCurp/${curp}.PNG`;
            console.log("🔍 Intentando fallback:", url2);
            imgPart = await loadLocalImage(url2);
            console.log("✅ Foto CURP cargada (.PNG):", curp);
          } catch (e2) {
            console.error("❌ Error .PNG:", e2);
            console.warn("⚠️ Foto CURP no encontrada, se genera sin foto.");
          }
        }

        // Agregar foto si existe
        if (imgPart) {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          const rm = 4, w = 150, h = 150;
          canvas.width = w * rm;
          canvas.height = h * rm;
          ctx.beginPath();
          ctx.ellipse((w * rm) / 3, (h * rm) / 2, (w * rm) / 3, (h * rm) / 2, 0, 0, Math.PI * 2);
          ctx.closePath();
          ctx.clip();
          ctx.drawImage(imgPart, -25 * rm, 0, w * rm, h * rm);
          doc.addImage(canvas.toDataURL("image/png"), "PNG", 127, 311, w, h);
        }

        // Texto del nombre
        doc.setFont("Oswald", "normal");
        doc.setFontSize(35);
        doc.splitTextToSize(nombreCompleto.toUpperCase(), 250).forEach((line, i) => {
          doc.text(line, 270, 383 + i * 30, { align: "left" });
        });

        // Datos del certificado
        doc.setFont("RobotoBold", "normal");
        doc.setFontSize(12);
        doc.text(`${delegacion_local || ""} ${delegacion_estatal || ""}`, 258, 459, { align: "left" });
        doc.text(folio, 183, 696, { align: "left" });
        doc.text(new Date(fecha_emision).toLocaleDateString("es-MX"), 370, 696, { align: "left" });
        doc.text(formatearFecha(vigencia).replace("de", "del"), 227, 719, { align: "left" });
        doc.save(`CertificadoInst_${folio}.pdf`);
      } catch (err) {
        console.error("Error al generar CECAP:", err);
      }
      return;
    }

    // ── FONE: landscape + plantilla por clave ────────────────────
    if (tipo === "FONE") {
      const baseW = 792, baseH = 612;
      const doc = new jsPDF({ orientation: "landscape", unit: "px", format: [baseW, baseH] });

      try {
        await Promise.all([
          addFontToDoc(doc, Oswald, "Oswald-Medium.ttf", "Oswald"),
          addFontToDoc(doc, Roboto, "Roboto-Medium.ttf", "Roboto"),
          addFontToDoc(doc, RobotoLight, "Roboto-Light.ttf", "RobotoLight"),
          addFontToDoc(doc, RobotoBold, "Roboto-Bold.ttf", "RobotoBold"),
        ]);

        const clave = (cert.clave || nombre_curso || "").toString().toUpperCase();
        const bgImg = await loadImageHelper(`/assets/certificate/${clave}.png`);
        const bgData = imageToDataUrl(bgImg);
        const ratio = Math.min(baseW / bgImg.naturalWidth, baseH / bgImg.naturalHeight);
        const drawW = bgImg.naturalWidth * ratio;
        const drawH = bgImg.naturalHeight * ratio;
        const x = (baseW - drawW) / 2;
        const y = (baseH - drawH) / 2;
        const scaleW = drawW / baseW;
        const scaleH = drawH / baseH;
        doc.addImage(bgData, "PNG", x, y, drawW, drawH);

        const X = (x0) => x + x0 * scaleW;
        const Y = (y0) => y + y0 * scaleH;

        doc.setFont("Oswald", "normal");
        doc.setFontSize(35);
        doc.splitTextToSize(nombreCompleto.toUpperCase(), 460 * scaleW).forEach((line, i) => {
          doc.text(line, X(395), Y(255 + i * 30), { align: "center" });
        });

        doc.setFont("RobotoBold", "normal");
        doc.setFontSize(12);
        const delegTexto = [delegacion_estatal, delegacion_local].filter(Boolean).join(", ");
        doc.text(delegTexto, X(270), Y(535), { align: "left" });
        doc.text(String(folio || ""), X(270), Y(550), { align: "left" });
        doc.text(new Date(vigencia).toLocaleDateString("es-MX"), X(452), Y(535), { align: "left" });
        doc.text(new Date(fecha_emision).toLocaleDateString("es-MX"), X(452), Y(550), { align: "left" });
        doc.save(`CertificadoInst_${folio}.pdf`);
      } catch (err) {
        console.error("Error al generar FONE:", err);
      }
      return;
    }

    // ── APS: landscape + plantilla por clave ─────────────────────
    if (tipo === "APS") {
      const pageW = 762, pageH = 542;
      const doc = new jsPDF({ orientation: "landscape", unit: "px", format: [pageW, pageH] });

      try {
        await Promise.all([
          addFontToDoc(doc, Oswald, "Oswald-Medium.ttf", "Oswald"),
          addFontToDoc(doc, Roboto, "Roboto-Medium.ttf", "Roboto"),
          addFontToDoc(doc, RobotoLight, "Roboto-Light.ttf", "RobotoLight"),
          addFontToDoc(doc, RobotoBold, "Roboto-Bold.ttf", "RobotoBold"),
        ]);

        const clave = (cert.clave || nombre_curso || "APB").toString().toUpperCase();
        const bgImg = await loadImageHelper(`/assets/certificate/${clave}.png`);
        const bgData = imageToDataUrl(bgImg);
        const ratio = Math.min(pageW / bgImg.naturalWidth, pageH / bgImg.naturalHeight);
        const drawW = bgImg.naturalWidth * ratio;
        const drawH = bgImg.naturalHeight * ratio;
        const x = (pageW - drawW) / 2;
        const y = (pageH - drawH) / 2;
        doc.addImage(bgData, "PNG", x, y, drawW, drawH);

        doc.setFont("RobotoLight", "normal");
        doc.setFontSize(35);
        doc.text(nombreCompleto.toUpperCase(), 395, 310, { align: "center" });

        doc.setFont("RobotoLight", "normal");
        doc.setFontSize(12);
        const delegTexto = [delegacion_estatal, delegacion_local].filter(Boolean).join(", ");
        doc.text(delegTexto, 620, 473, { align: "left" });
        doc.text(String(folio || ""), 620, 486, { align: "left" });
        doc.text(new Date(fecha_emision).toLocaleDateString("es-MX"), 620, 500, { align: "left" });
        doc.save(`CertificadoAPS_${folio}.pdf`);
      } catch (err) {
        console.error("Error al generar APS:", err);
      }
    }
  };

  return (
    <>
      <ImageTitle title="CERTIFICADOS" subtitle="INSTITUCIONALES" image={CatalogImage} />

      {/* ── SECCIÓN CERTIFICADOS INSTITUCIONALES ── */}
      <GreenDiv>
        <Title>BUSCA TUS CERTIFICADOS</Title>
      </GreenDiv>

      <Descripcion>
        Ingresa tu CURP para consultar todos los certificados emitidos a tu nombre.
        Una vez localizada tu información podrás descargar cada certificado en formato PDF.
      </Descripcion>

      {/* Buscador por CURP */}
      <SearchCard as="form" onSubmit={handleSearchCurp}>
        <Box sx={{ fontFamily: "DM Sans", fontWeight: 700, fontSize: 15, color: "#333" }}>
          CURP
        </Box>
        <SearchRow>
          <TextField
            fullWidth
            variant="outlined"
            value={curp}
            onChange={(e) => { setCurp(e.target.value.toUpperCase()); setErrorCurp(""); }}
            placeholder="Ingresa tu CURP"
            inputProps={{ maxLength: 18, style: { fontFamily: "DM Sans" } }}
            size="medium"
            error={!!errorCurp}
          />
          <Button
            type="submit"
            variant="contained"
            disabled={loadingCurp}
            startIcon={loadingCurp ? <CircularProgress size={18} color="inherit" /> : <IoIosSearch size={18} />}
            sx={{
              backgroundColor: "#069640",
              fontFamily: "DM Sans",
              fontWeight: 700,
              fontSize: 14,
              borderRadius: "10px",
              padding: "15px 28px",
              whiteSpace: "nowrap",
              "&:hover": { backgroundColor: "#005522" },
            }}
          >
            {loadingCurp ? "Buscando..." : "BUSCAR CERTIFICADOS"}
          </Button>
        </SearchRow>
        {errorCurp && (
          <Alert severity="error" sx={{ fontFamily: "DM Sans" }}>{errorCurp}</Alert>
        )}
      </SearchCard>

      {/* Resultados CURP */}
      {resultadosCurp && (
        <>
          {/* Bienvenida */}
          <WelcomeBar>
            <Box sx={{
              width: 48, height: 48, borderRadius: "50%",
              background: "#069640", display: "flex",
              alignItems: "center", justifyContent: "center", flexShrink: 0,
            }}>
              <MdPerson color="white" size={26} />
            </Box>
            <Box sx={{ flex: 1 }}>
              <Box sx={{ fontFamily: "DM Sans", fontWeight: 700, fontSize: 18, color: "#222" }}>
                {usuarioInfo
                  ? `¡Bienvenido, ${usuarioInfo.nombre_completo}!`
                  : "¡Certificados encontrados!"}
              </Box>
              {usuarioInfo && (
                <Box sx={{ fontFamily: "DM Sans", fontSize: 13, color: "#666", mt: 0.5 }}>
                  CURP: {curp}&nbsp;&nbsp;|&nbsp;&nbsp;
                  <span style={{ color: "#069640", fontWeight: 700 }}>
                    Certificados encontrados: {resultadosCurp.length}
                  </span>
                </Box>
              )}
            </Box>
          </WelcomeBar>

          {/* Alerta resumen */}
          <Box sx={{ width: "70%", margin: "8px auto", "@media (max-width: 768px)": { width: "90%" } }}>
            <Alert
              severity="success"
              icon={<MdVerified size={20} />}
              sx={{ fontFamily: "DM Sans", borderRadius: "10px" }}
            >
              Se encontraron <strong>{resultadosCurp.length}</strong> certificado{resultadosCurp.length !== 1 ? "s" : ""} asociado{resultadosCurp.length !== 1 ? "s" : ""} a la CURP ingresada.
            </Alert>
          </Box>

          {/* Tarjetas de certificados */}
          <CertGrid>
            {resultadosCurp.map((cert, i) => (
              <CertCard key={i}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                  <BsFilePdfFill color="#d31414" size={22} />
                  <Box sx={{ fontFamily: "DM Sans", fontWeight: 700, fontSize: 16, color: "#222" }}>
                    {nombreCursoFormateado(cert)}
                  </Box>
                </Box>

                <Divider />

                <CertRow>
                  <BsCalendar2Check color="#069640" size={15} />
                  <span>Fecha de emisión: <strong>{formatDate(cert.fecha_emision)}</strong></span>
                </CertRow>

                {cert.folio && (
                  <CertRow>
                    <BsTag color="#069640" size={15} />
                    <span>Folio: <strong style={{ fontFamily: "monospace", color: "#005522" }}>{cert.folio}</strong></span>
                  </CertRow>
                )}

                <CertRow>
                  <BsShieldCheck color="#069640" size={15} />
                  <span>Estado: <strong style={{ color: cert.estatus === "Vigente" ? "#069640" : "#d31414" }}>{cert.estatus || "Vigente"}</strong></span>
                </CertRow>

                <Button
                  variant="contained"
                  fullWidth
                  startIcon={<MdDownload size={18} />}
                  onClick={() => generarConstancia(cert)}
                  sx={{
                    mt: 1,
                    backgroundColor: "#069640",
                    fontFamily: "DM Sans",
                    fontWeight: 700,
                    borderRadius: "8px",
                    "&:hover": { backgroundColor: "#005522" },
                  }}
                >
                  DESCARGAR CERTIFICADO
                </Button>
              </CertCard>
            ))}
          </CertGrid>

          {/* Nota al pie */}
          <Box sx={{
            width: "70%", margin: "8px auto 24px auto",
            "@media (max-width: 768px)": { width: "90%" }
          }}>
            <Alert severity="info" sx={{ fontFamily: "DM Sans", borderRadius: "10px" }}>
              ¿No encuentras algún certificado? Comunícate con tu coordinación local para más información.
            </Alert>
          </Box>
        </>
      )}

      <Divider sx={{ my: 4, width: "80%", mx: "auto" }} />

      {/* ── SECCIÓN CONSTANCIAS EXTERNAS ── */}
      <GreenDiv>
        <Title>VALIDACIÓN DE CONSTANCIAS EXTERNAS</Title>
      </GreenDiv>

      <Descripcion>
        Para constancias de capacitación externa (CENCAD y CEC), ingresa el nombre del participante.
        <br />
        <strong>Nota:</strong> Solo se confirma la existencia del registro. La constancia física es el comprobante oficial.
      </Descripcion>

      <FormContainer onSubmit={handleSearchExterno}>
        <ToggleButtonGroup
          value={tipoExterno}
          exclusive
          onChange={(e, newValue) => newValue && setTipoExterno(newValue)}
          sx={{
            display: "flex", flexDirection: "row", m: "10px",
            justifyContent: "center", width: "100%", gap: "10px",
          }}
        >
          <ToggleButton value="CENCAD">CENCAD</ToggleButton>
          <ToggleButton value="CEC">CEC</ToggleButton>
        </ToggleButtonGroup>

        <TextField
          fullWidth
          label="Nombre del participante"
          variant="outlined"
          value={nombre}
          onChange={(e) => setNombre(e.target.value.toUpperCase())}
          placeholder="Ej: JUAN PÉREZ GARCÍA"
          sx={{ m: "10px", width: "100%" }}
        />

        <Button
          type="submit"
          variant="contained"
          disabled={loadingExterno}
          startIcon={loadingExterno ? <CircularProgress size={20} color="inherit" /> : <IoIosSearch />}
          sx={{
            backgroundColor: "#005522", m: "10px", px: 4, py: 1.5,
            fontSize: "16px", fontWeight: "bold", borderRadius: "12px",
            boxShadow: "0px 4px 8px rgba(0,0,0,0.2)",
            "&:hover": { backgroundColor: "#069640", transform: "scale(1.05)" },
            width: "100%",
          }}
        >
          {loadingExterno ? "Buscando..." : "Validar Constancia"}
        </Button>
      </FormContainer>

      {errorExterno && (
        <Alert severity="error" sx={{ mt: 3, width: "80%", mx: "auto" }}>
          {errorExterno}
        </Alert>
      )}

      {resultadoExterno && (
        <Card sx={{ mt: 4, width: "80%", mx: "auto", bgcolor: "#f5f5f5", borderLeft: "5px solid #069640" }}>
          <CardContent>
            <Typography variant="h6" color="primary" gutterBottom sx={{ textAlign: "center" }}>
              ✓ Constancia Encontrada
            </Typography>
            <Divider sx={{ my: 2 }} />

            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="subtitle2" color="text.secondary">Participante:</Typography>
                <Typography variant="h5" sx={{ fontWeight: "bold" }}>{resultadoExterno.nombre_completo}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="text.secondary">Tipo:</Typography>
                <Typography variant="body1" sx={{ fontWeight: "bold" }}>{resultadoExterno.tipo}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="text.secondary">Estatus:</Typography>
                <Typography variant="body1" fontWeight="bold"
                  color={resultadoExterno.estatus === "VÁLIDO" || resultadoExterno.estatus === "VALIDO" ? "success.main" : "error.main"}>
                  {resultadoExterno.estatus}
                </Typography>
              </Grid>
              {resultadoExterno.nombre_curso && (
                <Grid item xs={12}>
                  <Typography variant="subtitle2" color="text.secondary">Curso:</Typography>
                  <Typography variant="body1">{resultadoExterno.nombre_curso}</Typography>
                </Grid>
              )}
              {resultadoExterno.horas && (
                <Grid item xs={12} sm={4}>
                  <Typography variant="subtitle2" color="text.secondary">Duración:</Typography>
                  <Typography variant="body1">{resultadoExterno.horas} horas</Typography>
                </Grid>
              )}
              {resultadoExterno.fecha_inicio && (
                <Grid item xs={12} sm={4}>
                  <Typography variant="subtitle2" color="text.secondary">Fecha de Inicio:</Typography>
                  <Typography variant="body1">{formatDate(resultadoExterno.fecha_inicio)}</Typography>
                </Grid>
              )}
              {resultadoExterno.fecha_fin && (
                <Grid item xs={12} sm={4}>
                  <Typography variant="subtitle2" color="text.secondary">Fecha de Conclusión:</Typography>
                  <Typography variant="body1">{formatDate(resultadoExterno.fecha_fin)}</Typography>
                </Grid>
              )}
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="text.secondary">Fecha de Emisión:</Typography>
                <Typography variant="body1">{formatDate(resultadoExterno.fecha_emision)}</Typography>
              </Grid>
              {resultadoExterno.folio && (
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="text.secondary">Folio:</Typography>
                  <Typography variant="body1"
                    sx={{ fontFamily: "monospace", fontWeight: "bold", letterSpacing: 1, color: "#005522" }}>
                    {resultadoExterno.folio}
                  </Typography>
                </Grid>
              )}
            </Grid>

            <Divider sx={{ my: 2 }} />

            {resultadoExterno.qr_url && (
              <Box sx={{ mb: 1 }}>
                <Button size="small" variant="outlined"
                  onClick={() => setMostrarQR((v) => !v)}
                  sx={{ color: "#005522", borderColor: "#005522", textTransform: "none", mb: 1 }}>
                  {mostrarQR ? "▲ Ocultar código QR" : "▼ Ver código QR de verificación"}
                </Button>
                <Collapse in={mostrarQR}>
                  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1, p: 2, bgcolor: "#fff", borderRadius: 2, border: "1px solid #e0e0e0" }}>
                    <QRCodeSVG value={resultadoExterno.qr_url} size={160} bgColor="#ffffff" fgColor="#005522" level="H" includeMargin />
                    <Typography variant="caption" color="text.secondary" textAlign="center">
                      Escanea para verificar la autenticidad en línea
                    </Typography>
                  </Box>
                </Collapse>
              </Box>
            )}

            {resultadoExterno.folio && (
              <Box>
                <Button size="small" variant="outlined"
                  onClick={() => setMostrarSeguridad((v) => !v)}
                  sx={{ color: "#555", borderColor: "#aaa", textTransform: "none", mb: 1 }}>
                  {mostrarSeguridad ? "▲ Ocultar verificación adicional" : "▼ Verificación adicional (código de seguridad)"}
                </Button>
                <Collapse in={mostrarSeguridad}>
                  <Box sx={{ p: 2, bgcolor: "#fff", borderRadius: 2, border: "1px solid #e0e0e0" }}>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                      Ingresa el código de 8 caracteres impreso en tu constancia física.
                    </Typography>
                    <Box sx={{ display: "flex", gap: 1, alignItems: "flex-start", flexWrap: "wrap" }}>
                      <TextField
                        label="Código de seguridad"
                        value={codigoSeguridad}
                        onChange={(e) => setCodigoSeguridad(e.target.value.toUpperCase())}
                        size="small"
                        inputProps={{ maxLength: 8, style: { fontFamily: "monospace", letterSpacing: 2 } }}
                        placeholder="Ej: A3F9B2C1"
                        sx={{ width: 200 }}
                      />
                      <Button variant="contained"
                        onClick={handleVerificarCodigo}
                        disabled={loadingCodigo || codigoSeguridad.length !== 8}
                        sx={{ bgcolor: "#005522", "&:hover": { bgcolor: "#069640" }, minWidth: 110 }}>
                        {loadingCodigo ? <CircularProgress size={20} sx={{ color: "#fff" }} /> : "Verificar"}
                      </Button>
                    </Box>
                    {resultadoCodigo && (
                      <Alert severity={resultadoCodigo.valido ? "success" : "error"} sx={{ mt: 1.5 }}>
                        {resultadoCodigo.valido ? "✓ Código correcto. Constancia verificada con segundo factor." : resultadoCodigo.mensaje || "Código incorrecto."}
                      </Alert>
                    )}
                  </Box>
                </Collapse>
              </Box>
            )}

            <Typography variant="caption" display="block" sx={{ mt: 2, textAlign: "center", fontStyle: "italic" }}>
              * Esta validación confirma la existencia del registro. La constancia física es el comprobante oficial.
            </Typography>
          </CardContent>
        </Card>
      )}

      <Descripcion>
        Si tu certificado institucional digital presenta información incorrecta o incompleta, por favor notifícalo al siguiente correo electrónico:
        <br />
        👉 <strong>plataformacrmsn@gmail.com</strong>
        <br />
        No se revisarán solicitudes pasado un mes de la fecha de emisión del mismo.
      </Descripcion>
    </>
  );
};

export default Certificates;